import OlMap from 'ol/Map';
import Feature, { FeatureLike } from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { fromLonLat } from 'ol/proj';
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';
import { ControlPoint } from 'src/app/bo/controlPoint';
import { FEATURE_KIND, FEATURE_LABEL, Z_INDEX } from '../site-map.constants';

export class ControlPointsLayer {
  private readonly source = new VectorSource<Feature<Point>>();
  private readonly layer = new VectorLayer({
    source: this.source,
    zIndex: Z_INDEX.controlPoints,
    style: feature => this.styleFor(feature),
  });
  private readonly styleCache = new Map<string, Style>();

  constructor(private readonly map: OlMap) {
    map.addLayer(this.layer);
  }

  /** Seuls les points actifs sont affichés ; l'API les renvoie en WGS84 (transformCoord=false). */
  setPoints(points: ControlPoint[]): void {
    this.source.clear();
    this.source.addFeatures(points
      .filter(point => point.isActif && Number.isFinite(point.x) && Number.isFinite(point.y))
      .map(point => {
        const feature = new Feature({ geometry: new Point(fromLonLat([point.x, point.y])) });
        feature.setProperties({ [FEATURE_KIND]: 'control-point', [FEATURE_LABEL]: point.name ?? '' }, true);
        return feature;
      }));
  }

  setVisible(visible: boolean): void {
    this.layer.setVisible(visible);
  }

  dispose(): void {
    this.map.removeLayer(this.layer);
    this.source.clear();
    this.styleCache.clear();
  }

  private styleFor(feature: FeatureLike): Style {
    const label: string = feature.get(FEATURE_LABEL);
    let style = this.styleCache.get(label);
    if (!style) {
      style = new Style({
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({ color: 'orange' }),
          stroke: new Stroke({ color: '#7E003F', width: 1 }),
        }),
        text: new Text({
          text: label,
          font: '12px Calibri,sans-serif',
          fill: new Fill({ color: 'rgba(255, 255, 255, 1)' }),
          backgroundFill: new Fill({ color: 'rgba(0, 0, 0, 0.4)' }),
          padding: [2, 2, 2, 2],
          textBaseline: 'bottom',
          offsetY: -12,
        }),
      });
      this.styleCache.set(label, style);
    }
    return style;
  }
}
